// extracted by mini-css-extract-plugin
export default {"name_flag_container":"styles_name_flag_container__xMA5y","divider":"styles_divider__zhYlp"};